export default __webpack_public_path__ + "static/media/blueX.f1e35b37.svg";